export default "__VITE_ASSET__BAv_tHzr__"